import { useState } from "react";
import Styles from "./dropdown.module.css";
import { ICONS } from "../Icon";

const SelectionDropdown = (props) => {
  const {
    dropdownTitle = "Dropdown Title",
    list = ["Option 1", "Option 2", "Option 3"],
    placeholder = "Placeholder",
    onSelection = () => {},
    resetOnSelection = false,
    onClick=()=>{},
    disabled = false,
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(placeholder);
  const isSelected = list?.some(e=>e===selectedOption);
  
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    if(!isOpen)onClick();
  };

  const handleOptionClick = (option) => {
    setIsOpen(false);
    onSelection(option);
    if (resetOnSelection) setSelectedOption(placeholder);
    else setSelectedOption(option);
  };

  return (
    <div className={Styles.dropdowncontainer}>
      <h3 className={Styles.dropdowntitle}>{dropdownTitle}</h3>
      <div className={`${Styles.dropdown} ${isSelected && Styles.dropdown_active} ${disabled && Styles.dropdown_disabled}`} 
           onClick={!disabled ? toggleDropdown : undefined}>
        <div className={`${Styles.dropdownplaceholder} ${isSelected && Styles.dropdownplaceholder_active}`} >
          <p className={Styles.dropdownplaceholderTitle}>{selectedOption}</p>
          <span className={Styles.chevron}>
            <img
              src={ICONS.chevronLeftWhite}
              width={"10px"}
              style={{ transform: isOpen ? "rotate(90deg)" : "rotate(270deg)" }}
            />
          </span>
        </div>
        {isOpen && (
          <div className={Styles.dropdownmenu}>
            {list?.map((option, index) => (
              <div
                key={index}
                className={Styles.dropdownitem}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectionDropdown;
